import React from "react";
import { Card, CardContent, Stack, Tab, Tabs, Typography } from "@mui/material";

export const SOCIAL_PLATFORMS = [
  { id: "x", label: "X" },
  { id: "threads", label: "Threads" },
  { id: "instagram", label: "Instagram" },
  { id: "linkedin", label: "LinkedIn" },
];

const PlatformPreview = ({ platform, onPlatformChange, variant }) => (
  <Card variant="outlined">
    <Tabs
      aria-label="Social platform"
      onChange={(_, value) => onPlatformChange(value)}
      value={platform}
      variant="scrollable"
    >
      {SOCIAL_PLATFORMS.map(({ id, label }) => (
        <Tab key={id} label={label} value={id} />
      ))}
    </Tabs>
    <CardContent>
      {variant ? (
        <Stack spacing={1.5} aria-label="Post preview">
          {variant.hook && (
            <Typography variant="h6" fontWeight={800}>
              {variant.hook}
            </Typography>
          )}
          {variant.body && <Typography>{variant.body}</Typography>}
          {variant.cta && (
            <Typography color="text.secondary">{variant.cta}</Typography>
          )}
        </Stack>
      ) : (
        <Typography color="text.secondary">
          Generate copy to preview this post.
        </Typography>
      )}
    </CardContent>
  </Card>
);

export default PlatformPreview;
